import React, { useEffect, useMemo } from "react";
import { darkBlue } from "../styles/colors";
import HeaderTitle from "../components/design/HeaderTitle";
import HeaderDescription from "../components/design/HeaderDescription";
import Button from "../components/design/Button";
import { useRouter } from "../hooks/useRouter";
import { useParams, useLocation } from "react-router-dom";
import Txt from "../components/Txt";
import { usePCRC } from "../context/PCRCContext";

function getErrorData(errorCode, description) {
  let errorData;

  switch (errorCode) {
    case 1:
      errorData = {
        title: "Utente non autorizzato",
        subtitle: (
          <>
            <Txt>L'utente non è presente nell'anagrafe regionale assistiti</Txt>
            .
            <br />
            <Txt>
              Pertanto non è possibile utilizzare i servizi di Scelta e Revoca
              MMG/PLS
            </Txt>
            .
          </>
        ),
      };
      break;
    case 2:
      errorData = {
        title: "Servizio non disponibile",
        subtitle: (
          <>
            <Txt>Il servizio Scelta e Revoca non è al momento disponibile</Txt>.
            <br />
            <Txt>Ti invitiamo a riprovare più tardi</Txt>.
          </>
        ),
      };
      break;
    case 3:
      errorData = {
        title: "Scelta non applicabile",
        subtitle: (
          <>
            <Txt>{description}</Txt>.
          </>
        ),
      };
      break;
    case 4:
      errorData = {
        title: "Dati inseriti non validi",
        subtitle: (
          <>
            <br />
            <Txt>
              Attenzione, il codice fiscale e la tessera sanitaria
              dell'assistito tutelato non corrispondono.
            </Txt>
          </>
        ),
      };
      break;
    case 5:
      errorData = {
        title: "Dati inseriti non validi",
        subtitle: (
          <>
            <br />
            <Txt>
              Attenzione: il codice fiscale e/o il numero di Tessera sanitari
              inseriti non sono validi.
            </Txt>
          </>
        ),
      };
      break;
    case 6:
      errorData = {
        title: "Dati inseriti non validi",
        subtitle: (
          <>
            <br />
            <Txt>
              Attenzione: per procedere è necessario accettare l’autorizzazione
              al trattamento dei dati del minore
            </Txt>
          </>
        ),
      };
      break;
    case 7:
      errorData = {
        title: "Codice fiscale non presente nell’anagrafe assistiti",
        subtitle: (
          <>
            <br />
            <Txt>
              Attenzione: il codice fiscale inserito non risulta presente
              nell’anagrafe assistiti regionale. Verificare il valore inserito
              e, se corretto, rivolgersi alla propria ASL di assistenza
            </Txt>
          </>
        ),
      };
      break;
    case 8:
      errorData = {
        title: "Assistito già presente",
        subtitle: (
          <>
            <br />
            <Txt>
              Attenzione: l’assistito che si sta tentando di aggiungere è già
              presente tra i suoi figli
            </Txt>
          </>
        ),
      };
      break;
    case 9:
      errorData = {
        title:
          "Nessuna corrispondenza tra il codice fiscale ed il numero di tessera",
        subtitle: (
          <>
            <br />
            <Txt>
              Attenzione: in base ai dati presenti nell'anagrafe regionale, non
              c'è corrispondenza tra il codice fiscale ed il numero di tessera
              sanitaria inseriti
            </Txt>
          </>
        ),
      };
      break;
    case 10:
      errorData = {
        title: "Assistito deceduto",
        subtitle: (
          <>
            <br />
            <Txt>
              Attenzione: in base ai dati presenti nell'anagrafe regionale,
              l'assistito risulta deceduto. Pertanto, non è possibile
              aggiungerlo
            </Txt>
          </>
        ),
      };
      break;
    case 11:
      errorData = {
        title: "Iscrizione ASL Scaduta",
        subtitle: (
          <>
            <br />
            <Txt>
              Attenzione: in base ai dati presenti nell'anagrafe regionale,
              l'iscrizione dell'assistito all'ASL risulta scaduta
            </Txt>
          </>
        ),
      };
      break;
    case 12:
      errorData = {
        title: "Assistito maggiorenne",
        subtitle: (
          <>
            <br />
            <Txt>
              {" "}
              Attenzione: non è possibile inserire i propri figli se maggiorenni
            </Txt>
          </>
        ),
      };
      break;
    case 13:
      errorData = {
        title: "Impossibile cambiare medico",
        subtitle: (
          <>
            <br />
            <Txt>
              {" "}
              Attenzione: Impossibile cambiare medico in quanto è stato cambiato
              da meno di 30 giorni
            </Txt>
          </>
        ),
      };
      break;
    case 14:
      errorData = {
        title: "Errore durante caricamento lista medici",
        subtitle: (
          <>
            <br />
            <Txt>
              Si è verificato un errore durante il caricamento della lista
              medici, si è pregati di riprovare più tardi.
            </Txt>
          </>
        ),
      };
      break;
    case 15:
      errorData = {
        title: "Errore durante procedura cambio medico",
        subtitle: (
          <>
            <br />
            <Txt>
              Si è verificato un errore durante la procedura di cambio medico,
              si è pregati di riprovare più tardi.
            </Txt>
          </>
        ),
      };
      break;
    case 16:
      errorData = {
        title: "Errore durante caricamento assistiti",
        subtitle: (
          <>
            <br />
            <Txt>
              Si è verificato durante il caricamento degli assistiti, si è
              pregati di riprovare più tardi.
            </Txt>
          </>
        ),
      };
      break;
    case 17:
      errorData = {
        title: "Errore durante rimozione assistito",
        subtitle: (
          <>
            <br />
            <Txt>
              Si è verificato durante la rimozione dell'assistito, si è
              pregati di riprovare più tardi.
            </Txt>
          </>
        ),
      };
      break;
    default:
      errorData = {
        title: "Servizio non disponibile",
        subtitle: (
          <>
            <Txt>
              Si è verificato un errore, pertanto non è possibile procedere con
              la richiesta
            </Txt>
            .
            <br />
            <Txt>Ti invitiamo a riprovare più tardi</Txt>.
          </>
        ),
      };
  }
  return errorData;
}

const Error = () => {
  const { scrollTop } = usePCRC();

  const { id } = useParams();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const desc = query?.get("desc");

  const router = useRouter();

  const errorData = useMemo(() => {
    return getErrorData(Number(id), desc);
  }, [id, desc]);

  const handleGoHome = () => {
    window.parentIFrame.sendMessage({ type: "NAVIGATE_TO", payload: "/" });
  };

  const handleGoDoctors = () => {
    router.push("/doctor");
  };

  useEffect(scrollTop, []);

  return (
    <div className="flex-center p-3r flex-column">
      <img
        style={{
          border: `5px solid ${darkBlue}`,
          padding: "0.5rem",
          borderRadius: "50%",
        }}
        src={`${process.env.PUBLIC_URL}/images/close.svg`}
        alt=""
      ></img>

      <HeaderTitle className="my-2r">
        {<Txt>{errorData.title}</Txt>}
      </HeaderTitle>
      <HeaderDescription className="text-center">
        {errorData.subtitle}
      </HeaderDescription>
      {id >= 3 && id !== 13 && id < 16 && (
        <Button
          style={{ backgroundColor: darkBlue, padding: "0.5rem 2rem" }}
          label="Torna alla lista medici"
          onClick={handleGoDoctors}
        ></Button>
      )}
      <Button
        style={{ backgroundColor: darkBlue, padding: "0.5rem 2rem" }}
        label="Torna alla homepage"
        onClick={handleGoHome}
      ></Button>
    </div>
  );
};

export default Error;
